"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("../../type/entity");
function getCompletionCriteriaForCardQuestionForReview(content) {
    if (!content.children || content.children.length > 0) {
        return entity_1.CompletionCriteria.MIN_PROGRESS_MEASURE;
    }
    return content.children[0].completionCriteria;
}
exports.getCompletionCriteriaForCardQuestionForReview = getCompletionCriteriaForCardQuestionForReview;
//# sourceMappingURL=getCompletionCriteriaForCardQuestionForReview.js.map